/**
 * Header Block for the Editor.js.
 *
 * @author Whizzy Corporation
 * @license The MIT License (MIT)
 * @version 1.0.0
 */

/**
 * @typedef {Object} HeaderData
 */
export default class Header {
	constructor({ data, config, api }) {
		this.api = api
		this.config = config || {}

		this.data = {
			text: data.text || '',
			alignment: data.alignment !== undefined ? data.alignment : 'left',
			level: data.level !== undefined ? data.level : '3',
			type: data.lineType !== undefined ? data.lineType : 'normal',
			textColor: data.textColor !== undefined ? data.textColor : '#333333',
			backgroundColor: data.backgroundColor !== undefined ? data.backgroundColor : '#ffffff',
			borderColor: data.borderColor !== undefined ? data.borderColor : '#FF7B7F',
		}

		this._setform = false

		this._element = this.drawView()
		this._fontSizeArray = ['', '', '1.75rem', '1.53125rem', '1.3125rem']

		// text復帰
		this._element.querySelector('div').innerHTML = this.data.text
		// font-size復帰
		this._element.style.fontSize = this._fontSizeArray[this.data.level]
		// 線種変更
		this._changeType(this.data.type)
		// alignment変更
		this._changeAlignment(this.data.alignment)
		// 線色変更
		this._setColor()

		this.settings = [
			{
				name: '2',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="14" viewBox="0 0 40 40"><path d="M17.885,3.148a51.133,51.133,0,0,1,.247,5.736V19.742H4.192V8.782a50.951,50.951,0,0,1,.247-5.634H1.54a51.133,51.133,0,0,1,.247,5.736V36.336a49.977,49.977,0,0,1-.247,5.736h2.9a50.552,50.552,0,0,1-.247-5.736V23.379h13.94V36.336a52.319,52.319,0,0,1-.247,5.736h2.9a52.924,52.924,0,0,1-.247-5.736V8.782a51.551,51.551,0,0,1,.247-5.634ZM37.747,42.073a21.047,21.047,0,0,1,3.793.307v-4.3a16.4,16.4,0,0,1-3.763.359H27.939A19.4,19.4,0,0,1,29.7,32.5a23.514,23.514,0,0,1,4.441-6.3c3.516-3.892,4.318-4.866,5.243-6.607a15.031,15.031,0,0,0,1.82-7.273c0-6.044-2.992-9.936-7.648-9.936a6.713,6.713,0,0,0-6.2,3.944c-1.018,1.9-1.48,3.688-1.943,7.375L28,14.416A15.2,15.2,0,0,1,29.08,9.243c.925-2.2,2.436-3.329,4.472-3.329,3.146,0,5.12,2.51,5.12,6.4,0,3.124-1.018,5.378-4.071,8.809-3.577,4.046-3.639,4.1-4.719,5.634a25.065,25.065,0,0,0-4.009,8.809,37.051,37.051,0,0,0-.894,6.761,13.425,13.425,0,0,1,3.392-.256Z" transform="translate(-1.54 -2.38)" fill="#707070"/></svg>',
				title: 'H2',
			},
			{
				name: '3',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="14" viewBox="0 0 40 40"><path d="M17.949-14.831A49.663,49.663,0,0,1,18.2-9.167V1.553H4.2V-9.268a49.486,49.486,0,0,1,.248-5.563H1.54a49.663,49.663,0,0,1,.248,5.664v27.1A48.54,48.54,0,0,1,1.54,23.6H4.45A49.1,49.1,0,0,1,4.2,17.938V5.144H18.2V17.938a50.815,50.815,0,0,1-.248,5.664h2.91a51.4,51.4,0,0,1-.248-5.664V-9.268a50.069,50.069,0,0,1,.248-5.563Zm6.687,30.139a16.97,16.97,0,0,0,1.579,4.905A7.429,7.429,0,0,0,33.15,24.36c5.17,0,8.39-4.248,8.39-11.075,0-3.236-.712-5.917-2.074-7.636a5.372,5.372,0,0,0-3.808-2.174,5.314,5.314,0,0,0,2.91-1.82c1.362-1.568,2.167-4.3,2.167-7.383,0-6.068-2.848-9.912-7.337-9.912a6.734,6.734,0,0,0-6.161,3.692,14.712,14.712,0,0,0-1.672,5.057l2.57.91a13.027,13.027,0,0,1,.991-3.59,4.252,4.252,0,0,1,4.118-2.68c3.127,0,4.985,2.528,4.985,6.877A9.627,9.627,0,0,1,36.989-.469a4.908,4.908,0,0,1-4.52,2.326,8.245,8.245,0,0,1-2.291-.3V5.548A13.439,13.439,0,0,1,32.655,5.3c4.118,0,6.316,2.731,6.316,7.737,0,4.8-2.26,7.838-5.851,7.838a5.1,5.1,0,0,1-3.994-1.82c-.96-1.113-1.393-2.174-1.889-4.8Z" transform="translate(-1.54 15.64)" fill="#707070"/></svg>',
				title: 'H3',
			},
			{
				name: '4',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="14" viewBox="0 0 40 40"><path d="M17.408-15.32a55.6,55.6,0,0,1,.24,5.895V1.733H4.115V-9.531a55.4,55.4,0,0,1,.24-5.789H1.54a55.6,55.6,0,0,1,.24,5.895V18.785a54.342,54.342,0,0,1-.24,5.895H4.354a54.967,54.967,0,0,1-.24-5.895V5.469H17.648V18.785a56.889,56.889,0,0,1-.24,5.895h2.814a57.547,57.547,0,0,1-.24-5.895V-9.531a56.055,56.055,0,0,1,.24-5.789Zm6.048,30a21.023,21.023,0,0,1,3.563-.211h8.024V19a53.3,53.3,0,0,1-.24,5.684h2.725A52.664,52.664,0,0,1,37.289,19V14.469H38.4a11.869,11.869,0,0,1,3.144.368V10.469a11.641,11.641,0,0,1-3.114.368H37.289V-6.425c0-4.158.03-5.789.18-8.895H35.223c-.689,1.842-1.228,3.158-2.246,5.368L25.4,6.68C24.774,8,24.085,9.469,23.456,10.733Zm11.617-3.789H26.121L33.007-4.373c.868-1.947,1.617-3.684,2.246-5.263-.15,2.684-.18,4.368-.18,7.158Z" transform="translate(-1.54 15.32)" fill="#707070"/></svg>',
				title: 'H4',
			},
			{
				name: 'left',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m10 23h28c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m10 45h28c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/></svg>',
				title: '左寄せ',
			},
			{
				name: 'center',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m46 23c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m46 45c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/></svg>',
				title: '中央寄せ',
			},
			{
				name: 'right',
				icon: '<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 19h-28c-1.104 0-2 .896-2 2s.896 2 2 2h28c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 41h-28c-1.104 0-2 .896-2 2s.896 2 2 2h28c1.104 0 2-.896 2-2s-.896-2-2-2z"/></svg>',
				title: '右寄せ',
			},
			{
				name: 'normal',
				icon: '通常',
				title: '枠も線もない見出し',
			},
			{
				name: 'left-line',
				icon: '左線',
				title: '左に線が引かれている見出し',
			},
			{
				name: 'under-line',
				icon: '下線',
				title: '下に線が引かれている見出し',
			},
			{
				name: 'updown-line',
				icon: '上下',
				title: '上下に線が引かれている見出し',
			},
			{
				name: 'border',
				icon: '枠線',
				title: '枠がある見出し',
			},
			{
				name: 'color',
				icon: '彩色',
				title: '色の設定',
			},
		]
	}

	drawView() {
		//console.log('Header.drawView');
		const containr = document.createElement('div')
		const textblock = document.createElement('div')
		const setblock = document.createElement('form')

		containr.classList.add('board-header')

		textblock.contentEditable = true

		containr.appendChild(textblock)
		containr.appendChild(setblock)

		return containr
	}

	render() {
		//console.log('Header.render');
		return this._element
	}

	renderSettings() {
		const wrapper = document.createElement('div')
		this.settings.forEach((tune) => {
			let button = document.createElement('div')

			button.classList.add(this.api.styles.settingsButton)
			button.setAttribute('title', tune.title)
			button.innerHTML = tune.icon
			wrapper.appendChild(button)

			this.api.tooltip.onHover(button, tune.title, {
				placement: 'top',
			})

			if (tune.name === 'normal' || tune.name === 'left-line' || tune.name === 'under-line' || tune.name === 'updown-line' || tune.name === 'border') {
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.type)
			} else if (tune.name === '2' || tune.name === '3' || tune.name === '4') {
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.level)
			} else if (tune.name === 'left' || tune.name === 'center' || tune.name === 'right') {
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.position)
			} else {
				if (this._setform) {
					button.classList.toggle(this.api.styles.settingsButtonActive)
				}
			}

			button.addEventListener('click', () => {
				if (
					tune.name === 'normal' ||
					tune.name === 'left-line' ||
					tune.name === 'under-line' ||
					tune.name === 'updown-line' ||
					tune.name === 'border'
				) {
					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach((el) => {
						if (
							el.innerHTML === '通常' ||
							el.innerHTML === '左線' ||
							el.innerHTML === '下線' ||
							el.innerHTML === '上下' ||
							el.innerHTML === '枠線'
						) {
							el.classList.remove(this.api.styles.settingsButtonActive)
						}
					})

					button.classList.add(this.api.styles.settingsButtonActive)

					this._changeType(tune.name)
				} else if (tune.name === '2' || tune.name === '3' || tune.name === '4') {
					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach((el) => {
						if (el.getAttribute('title') === '大' || el.getAttribute('title') === '中' || el.getAttribute('title') === '小') {
							el.classList.remove(this.api.styles.settingsButtonActive)
						}
					})

					button.classList.add(this.api.styles.settingsButtonActive)

					this._changeSize(tune.name)
				} else if (tune.name === 'left' || tune.name === 'center' || tune.name === 'right') {
					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach((el) => {
						if (el.getAttribute('title') === '左寄せ' || el.getAttribute('title') === '中央寄せ' || el.getAttribute('title') === '右寄せ') {
							el.classList.remove(this.api.styles.settingsButtonActive)
						}
					})

					button.classList.add(this.api.styles.settingsButtonActive)

					this._changeAlignment(tune.name)
				} else if (tune.name === 'color') {
					button.classList.toggle(this.api.styles.settingsButtonActive)
					if (button.classList.contains(this.api.styles.settingsButtonActive)) {
						this._showColorPicker(button)
						this._setform = true
					} else {
						this._hideColorPicker()
						this._setform = false
					}
				}
			})
		})

		return wrapper
	}

	_changeType(tune) {
		//console.log(`Header._changeType`);

		this._element.classList.remove(
			'board-header--normal',
			'board-header--left-line',
			'board-header--under-line',
			'board-header--updown-line',
			'board-header--border',
		)

		this._element.classList.add(`board-header--${tune}`)
		this.data.type = tune
	}

	_changeSize(tune) {
		const headerbox = this._element.querySelector('div')

		this.data.level = tune
		headerbox.style.fontSize = this._fontSizeArray[tune]
	}

	_changeAlignment(tune) {
		this.data.alignment = tune
		this._element.classList.remove('board-header--center', 'board-header--right', 'board-header--left')

		this._element.classList.add(`board-header--${tune}`)
	}

	_setColor() {
		const headerbox = this._element.querySelector('div')
		headerbox.style.color = this.data.textColor
		if (this.data.backgroundColor !== '#ffffff') {
			headerbox.style.background = this.data.backgroundColor
		}
		headerbox.style.borderColor = this.data.borderColor
	}

	_showColorPicker(button) {
		const setbox = this._element.querySelector('form')

		const textColor = document.createElement('input')
		const backgroundColor = document.createElement('input')
		const borderColor = document.createElement('input')

		textColor.type = 'color'
		textColor.value = this.data.textColor

		backgroundColor.type = 'color'
		backgroundColor.value = this.data.backgroundColor

		borderColor.type = 'color'
		borderColor.value = this.data.borderColor

		setbox.insertAdjacentHTML('beforeend', '文字色：')
		setbox.appendChild(textColor)
		setbox.insertAdjacentHTML('beforeend', '<br>背景色：')
		setbox.appendChild(backgroundColor)
		setbox.insertAdjacentHTML('beforeend', '<br>枠　色：')
		setbox.appendChild(borderColor)

		textColor.onchange = () => {
			const headerbox = this._element.querySelector('div')

			this.data.color = textColor.value
			headerbox.style.color = this.data.color

			button.classList.remove(this.api.styles.settingsButtonActive)
			this._hideColorPicker()
			this._setform = false
		}

		backgroundColor.onchange = () => {
			const headerbox = this._element.querySelector('div')
			this.data.backgroundColor = backgroundColor.value
			if (this.data.backgroundColor === '#ffffff') {
				headerbox.style.background = 'none'
			} else {
				headerbox.style.background = this.data.backgroundColor
			}
			if (
				(this.data.backgroundColor !== '#ffffff' && this._element.classList.contains('board-header--normal')) ||
				this._element.classList.contains('board-header--under-line') ||
				this._element.classList.contains('board-header--updown-line')
			) {
				headerbox.style.paddingLeft = '10px'
				headerbox.style.paddingRight = '10px'
			} else {
				headerbox.style.paddingLeft = ''
				headerbox.style.paddingRight = ''
			}

			button.classList.remove(this.api.styles.settingsButtonActive)
			this._hideColorPicker()
			this._setform = false
		}

		borderColor.onchange = () => {
			const headerbox = this._element.querySelector('div')
			this.data.borderColor = borderColor.value
			headerbox.style.borderColor = this.data.borderColor

			button.classList.remove(this.api.styles.settingsButtonActive)
			this._hideColorPicker()
			this._setform = false
		}
	}

	_hideColorPicker() {
		const setbox = this._element.querySelector('form')

		setbox.innerHTML = ''
	}

	save(toolsContent) {
		return {
			text: toolsContent.querySelector('div').innerHTML,
			level: this.data.level,
			lineType: this.data.type,
			alignment: this.data.alignment,
			textColor: this.data.textColor,
			borderColor: this.data.borderColor,
			backgroundColor: this.data.backgroundColor,
		}
	}

	validate(blockData) {
		return blockData.text.trim() !== ''
	}

	static get toolbox() {
		return {
			icon: '<svg width="10" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"><path d="M7.6 8.15H2.25v4.525a1.125 1.125 0 0 1-2.25 0V1.125a1.125 1.125 0 1 1 2.25 0V5.9H7.6V1.125a1.125 1.125 0 0 1 2.25 0v11.55a1.125 1.125 0 0 1-2.25 0V8.15z"/></svg>',
			title: '見出し',
		}
	}
}
